import * as React from 'react';
import { Classes, IProps, Link } from '../index';
import classNames from 'classnames';
import { LinkProps } from 'react-router-dom';

export interface IDetailMenuItemProps extends IProps {
  /**
   * Obsah/popisek komponenty
   */
  label: React.ReactNode;
  /**
   * Indikátor zda je prvek vybrán
   */
  active?: boolean;
  /**
   * Odkaz k přesměrování při kliknutí
   */
  link?: LinkProps;
  /**
   * Akce při kliknutí
   */
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

/**
 * DetailMenuItem - komponenta typicky pro navigaci v rámci stránky.
 */
export const DetailMenuItem: React.FC<IDetailMenuItemProps> = ({
  label,
  active,
  link,
  className,
  onClick,
  ...other
}) => {
  return (
    <>
      {link ? (
        <Link style={{ textDecoration: 'none', width: '100%' }} {...link}>
          <div
            className={classNames(
              Classes.DETAIL_MENU_ITEM,
              {
                [Classes.DETAIL_MENU_ITEM_ACTIVE]: active,
              },
              className
            )}
            {...other}
          >
            {label}
          </div>
        </Link>
      ) : (
        <div
          className={classNames(
            Classes.DETAIL_MENU_ITEM,
            {
              [Classes.DETAIL_MENU_ITEM_ACTIVE]: active,
            },
            className
          )}
          onClick={onClick}
          {...other}
        >
          {label}
        </div>
      )}
    </>
  );
};
